import React from 'react';
import PropTypes from 'prop-types';
import locationUtils from 'utils/locationUtils/locationUtils';
import Header from 'components/Header/Header';

import { browserHistory } from 'react-router';
import './ErrorPage.scss';

const goBack = (event) => {
  event.preventDefault();
  browserHistory.goBack();
};

const Landing = () => (
  <div className="error-page">
    <Header />
    <div className="container">
      <h1 className="error-page__heading">Oops, something went wrong</h1>
      <p className="error-page__blurb">Remember the more you share, the more miles you will match for your charity</p>
      <p className="error-page__blurb"><a href="" onClick={goBack}>Go back</a></p>
    </div>
  </div>
);

Landing.propTypes = {
  location: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object])),
};

Landing.defaultProps = {
  location: locationUtils.locationStub,
};

export default Landing;



// WEBPACK FOOTER //
// ./layouts/ErrorPage/ErrorPage.js